import { ALL_ITEMS_LABEL } from 'content/texts';


export const ALL_PRODUCTS_OPTION = {
  id: 'all',
  label: ALL_ITEMS_LABEL,
};
